module.exports = __webpack_public_path__ + "static/media/rocketUsecase.9b0f5781.png";